import request, { getDefaultRequestOptions } from 'utils/request';

export interface AuditExportPayload {
  resource_type: string;
  resource_id?: string;
  record_count?: number;
  export_format?: string;
  result_size_bytes?: number;
}

export async function auditExport(
  payload: AuditExportPayload,
  authToken: string
): Promise<void> {
  const options = getDefaultRequestOptions('POST', authToken, {
    event_name: 'data.exported',
    resource: {
      resource_type: payload.resource_type,
      ...(payload.resource_id && { resource_id: payload.resource_id }),
    },
    record_count: payload.record_count,
    export_format: payload.export_format,
    result_size_bytes: payload.result_size_bytes,
  });
  try {
    await request('/api/audit/events', options);
  } catch {
    // Fire-and-forget: audit failure must not block the export.
  }
}
